<div class="flex flex-col bg-white border border-neutral-200 rounded overflow-hidden">
  <div class="flex p-3 border-b border-neutral-200">
    <h3 class="m-0 font-semibold leading-none">{{media?.name}}</h3>
  </div>

  <div class="flex flex-row gap-3 p-3">
    <div class="flex items-center justify-center h-20 w-20 bg-gray-100 rounded-md overflow-hidden">
      <flow-media-preview [media]="media" [type]="media?.type" [fixedSize]="false"></flow-media-preview>
    </div>

    <div class="flex-1">
      <div class="grid grid-cols-3 gap-3">
        <flow-media-stats-item
          [tooltip]="'exposures.totalExposures'"
          [value]="media.totalExposures"
          [label]="'exposures.totalExposuresShort'"></flow-media-stats-item>

        <flow-media-stats-item
          [tooltip]="'exposures.airTime'"
          [value]="media.airTimeInSeconds"
          [label]="'exposures.airTime'"></flow-media-stats-item>

        <flow-media-stats-item
          [tooltip]="'exposures.attentionTime'"
          [value]="media.attentionTimeInSeconds"
          [label]="'exposures.attentionTimeShort'"></flow-media-stats-item>

        <flow-media-stats-item
          [tooltip]="'exposures.impressions'"
          [value]="media.impressions"
          [label]="'exposures.impressionsShort'"></flow-media-stats-item>

        <flow-media-stats-item
          [tooltip]="'exposures.shareOfVoice'"
          [value]="media.shareOfVoicePercentage"
          [label]="'exposures.shareOfVoiceShort'"></flow-media-stats-item>
      </div>
    </div>
  </div>

  <div
    class="flex-1 border-t border-neutral-200 bg-gray-50 overflow-hidden transition-all duration-200 ease-in-out"
    [ngClass]="{
      'max-h-0 opacity-0': !toggleExtendedInfo,
      'max-h-96 opacity-100': toggleExtendedInfo
    }">
    <div class="grid grid-cols-4 gap-3 p-3">
      <flow-media-stats-item
        [tooltip]="'exposures.totalNumberMen'"
        [value]="media.totalPerGender[0].count"
        [label]="'exposures.totalNumberMenShort'"></flow-media-stats-item>

      <flow-media-stats-item
        [tooltip]="'exposures.totalNumberWoman'"
        [value]="media.totalPerGender[1].count"
        [label]="'exposures.totalNumberWomanShort'"></flow-media-stats-item>

      <flow-media-stats-item
        [tooltip]="'exposures.primaryExposures'"
        [value]="media.primaryExposures ?? '-'"
        [dropdownList]="media.mediaTargetGroups"
        [label]="'exposures.primaryExposuresShort'"></flow-media-stats-item>

      <flow-media-stats-item
        [tooltip]="'exposures.secondaryExposures'"
        [value]="media.secondaryExposures ?? '-'"
        [label]="'exposures.secondaryExposuresShort'"></flow-media-stats-item>
    </div>

    <div class="border-t border-neutral-200 px-3 pb-3">
      <div class="grid grid-cols-3 gap-3 pt-3">
        <flow-media-stats-item
          [value]="media.clientName"
          [valueTooltip]="media.clientNameTooltip"
          [label]="'campaign.advertising.client'"></flow-media-stats-item>

        <flow-media-stats-item [value]="media.price" [label]="'campaign.advertising.price'"></flow-media-stats-item>

        <flow-media-stats-item
          [tooltip]="'campaign.advertising.pricingModel'"
          [value]="media.pricingModel"
          [valueTooltip]="media.pricingModelTooltip"
          [label]="'campaign.advertising.pricingModelShort'"></flow-media-stats-item>

        <ng-container *ngIf="media.bookingMediaPricingDetails?.pricingModel === PricingModelEnum.CPP">
          <flow-media-stats-item
            [tooltip]="'campaign.advertising.budgetedImpressions'"
            [value]="media.budgetedImpressions"
            [label]="'campaign.advertising.budgetedImpressionsShort'"></flow-media-stats-item>

          <flow-media-stats-item
            [tooltip]="'campaign.advertising.cppCampaignBudget'"
            [value]="media.cppCampaignBudget"
            [label]="'campaign.advertising.cppCampaignBudgetShort'"></flow-media-stats-item>

          <flow-media-stats-item [value]="media.totalCpp" [label]="'campaign.advertising.totalCpp'"></flow-media-stats-item>
        </ng-container>

        <ng-container *ngIf="media.bookingMediaPricingDetails?.pricingModel === PricingModelEnum.CPV">
          <flow-media-stats-item
            [tooltip]="'campaign.advertising.cpvCampaignBudget'"
            [value]="media.cpvCampaignBudget"
            [label]="'campaign.advertising.cpvCampaignBudgetShort'"></flow-media-stats-item>

          <flow-media-stats-item
            [tooltip]="'campaign.advertising.budgetedExposures'"
            [value]="media.budgetedExposures"
            [label]="'campaign.advertising.budgetedExposuresShort'"></flow-media-stats-item>

          <flow-media-stats-item [value]="media.totalCpv" [label]="'campaign.advertising.totalCpv'"></flow-media-stats-item>
        </ng-container>
      </div>
    </div>
  </div>
</div>
